import initSuitableSlider from './init-suitable-slider';
import initAboutSlider from './init-about-slider';
import initCasesSlider from './init-cases-slider';
import initExpertsSlider from './init-experts-slider';
import initDiplomSlider from './init-diplom-slider';
import initPartnersSlider from './init-partners-slider';
import initResumeSlider from './init-resume-slider';
import initYouBeAbleSlider from './init-youbeable-slider';
import initPaymentSlider from './init-payment-slider';



const sliders = () => {
  initSuitableSlider();
  initAboutSlider();
  initCasesSlider();
  initExpertsSlider();
  initDiplomSlider();
  initPartnersSlider();
  initResumeSlider();
  initYouBeAbleSlider();
  initPaymentSlider();
};

export default sliders;
